<template>
  <div class="block" id="auto-component">
    <div class="block-title center">
      <h2>Выберите тип доставки</h2>
    </div>
    <div class="delivery-buttons">
      <button
          v-tooltip="
          `${
            user.isShopInworkEdit && !base.isAdmin
              ? 'Изменять тип доставки с назначенным курьером запрещено'
              : ''
          }`
        "
          v-for="type in deliveryMethods"
          :key="type.id"
          class="delivery-button"
          :class="{
          active: type.id === order.deliveryMethod,
          hoverable: !user.isShopInworkEdit || base.isAdmin,
        }"
          @click.prevent="
          if (type.id !== order.deliveryMethod && (!user.isShopInworkEdit || base.isAdmin)) {
            setDeliveryMethod(type.id)
          }
        "
      >
        <i :class="`icon-${type.icon}`"></i>
        <span>{{ type.name }}</span>
      </button>
    </div>
    <div v-if="!user.isCanCreateOrder && !isAnonimousForm" class="accentuated-alert red">
      <span>Чтобы оформить заказ, </span>
      <a href="/cabinet/balance/addBalance">пополните баланс</a>
      <span> с расчетного счета вашей организации.</span>
    </div>
    <div class="accentuated-alert green">
      <strong>Подсказка</strong>: {{ getRandomHint() }}
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'

export default {
  name: 'DeliveryMethod',
  data() {
    return {
      hints: [
        'сэкономьте до 25%, оформив заказ на завтра',
        'сэкономьте 150 ₽, выбрав интервал отправки груза более 2 часов'
      ]
    }
  },
  computed: {
    ...mapState(GENERAL_STORE, ['deliveryMethods', 'base', 'user', 'order']),
    ...mapGetters(GENERAL_STORE, ['isAnonimousForm']),
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['updateDeliveryMethod']),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),

    setDeliveryMethod(id) {
      this.updateDeliveryMethod(id)
      this.calculatePrice()
    },
    getRandomHint() {
      const randomIndex = Math.floor(Math.random() * this.hints.length);
      return this.hints[randomIndex];
    },
  },
}
</script>

<style lang="scss" scoped>
.accentuated-alert {
  margin-top: 48px;
  margin-bottom: 0;
}
</style>
